import Navbar from './components/Navbar';
import Hero from './components/Hero';

export default function Home() {
  return (
    <main className="min-h-screen bg-black text-white antialiased" style={{ fontFamily: '"Inter", system-ui, sans-serif' }}>
      <Navbar />
      <Hero />
    </main>
  );
}